export default __webpack_public_path__ + "static/media/shadow-cold-winter.edc3286d.png";